import {Sube} from './sube';

export class KullaniciSube {

  sube: Sube;
  subeId: number;

  constructor(obj?: any) {
    if (obj == null) {
      return;
    }
    Object.assign(this, obj);
    if (obj.sube != null) {
      this.sube = new Sube(obj.sube);
    }
  }


}
